import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { APIResponse, ErrorResponse } from "@reflag/shared/api";
import {
  FeedbackTimelineItem,
  FeedbackTimelineQueryType,
} from "@reflag/shared/feedbackAPI";

import { feedbackQueryKeys } from "./feedbackQueryKeys";

export function useFeatureFeedbackTimelineData(
  query: FeedbackTimelineQueryType,
  options?: Omit<
    UseQueryOptions<
      APIResponse<FeedbackTimelineItem[]>,
      AxiosError<ErrorResponse>
    >,
    "queryKey" | "queryFn"
  >,
): UseQueryResult<
  APIResponse<FeedbackTimelineItem[]>,
  AxiosError<ErrorResponse>
> {
  const { envId, appId } = useEnvironment();
  return useQuery({
    queryKey: feedbackQueryKeys.timeline(appId, envId, query),
    queryFn: async () =>
      api
        .get<"/apps/:appId/feedback/timeline">(
          `/apps/${appId!}/feedback/timeline`,
          {
            params: { ...query },
          },
        )
        .then((res) => res.data),
    ...options,
  });
}
